import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    fetchClusterConfig,
    getClustersConfig,
    saveClusterConfig,
    setObjectTag,
    toggleVisibilityBudgetManagerModal,
} from './budget-manager.state';
import { BudgetManagerClusterConfigState, State } from './budget-manager.types';

export interface WithBudgetManagerProps {
    isBudgetManagerModalOpen: boolean,
    toggleVisibilityBudgetManagerModal: typeof toggleVisibilityBudgetManagerModal,
    clusterConfig: BudgetManagerClusterConfigState,
    setObjectTag: typeof setObjectTag,
    saveClusterConfig: typeof saveClusterConfig,
    fetchClusterConfig: typeof fetchClusterConfig,
}

export const withBudgetManager = connect(
    (state: State) => ({
        clusterConfig: getClustersConfig(state),
        isBudgetManagerModalOpen: state.dashboard.budgetManager.isBudgetManagerModalOpen,
    }),
    dispatch => bindActionCreators({
        fetchClusterConfig,
        saveClusterConfig,
        setObjectTag,
        toggleVisibilityBudgetManagerModal,
    }, dispatch),
);
